import {Injectable} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';

import {CheckMobileDeviceComponent} from './check-mobile-device.component';
import {EnvironmentHelper} from '@common-module/services/environment-helper';
import {LocalStorageKey} from '@common-module/app-enums/local-storage-key';
import {GlobalStyleClass} from '@common-module/app-enums/global-style-class.enum';

@Injectable({
  providedIn: 'root'
})

export class CheckDeviceService {

  constructor(public dialog: MatDialog,
              private readonly environmentHelper: EnvironmentHelper) { }

  public openDialog(): void {
    if (navigator.userAgent.includes('Android') && window.localStorage.getItem(LocalStorageKey.CHECK_DEVICE) !== 'disagree') {
      const dialogRef = this.dialog.open(CheckMobileDeviceComponent, {
        panelClass: ['check-device', GlobalStyleClass.DIALOG_SIZE_LIMIT],
        });
      dialogRef.afterClosed().subscribe(result => {
        if (result === 'agree') {
          window.location.href = this.environmentHelper.androidAppUrl;
        }
        if (result === 'disagree') {
          window.localStorage.setItem(LocalStorageKey.CHECK_DEVICE, result);
        }
      });
    }
  }
}
